import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { Component, ElementRef, ViewChild } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { catchError, of, Subscription } from 'rxjs'
import * as _ from 'lodash'
import { StatusOverview , Legend, Tree } from '@dataunveil/ducharts'

import dem from './dem/config'
import dpm from './dpm/config'
import { Modal as ModalDPM } from './dpm/modal'
import { Modal as ModalDEM } from './dem/modal'
import { TooltipDEM } from './dem/tooltip'
import { TooltipDPM } from './dpm/tooltip'
import moment from 'moment'
import { ChartsModule } from '../../shared/charts/charts.module'
import { ProgressIndefinite } from '../../shared/progress-indicator/indefinite'
import Widget from '../widget'
import { RouterHandlerService } from 'src/app/services/router-handler.service'
import { NavigationService } from 'src/app/services/navigation.service'
import { ControlChartDialogComponent } from './control-chart-dialog/control-chart-dialog.component'
import { TouchDblclickDirective } from 'src/app/directives/touch-dblclick.directive'

const widgetConfigs: { [key: string]: any } = {
  dem: {
    config: dem,
    modal: ModalDEM,
    tooltip: TooltipDEM,
    dateFormat: 'yyyy-MM-DD',
  },
  dpm: {
    config: dpm,
    modal: ModalDPM,
    tooltip: TooltipDPM,
    dateFormat: 'DD-MM-YY',
  },
  ffm: {
    config: dpm,
    modal: ModalDPM,
    tooltip: TooltipDPM,
    dateFormat: 'DD-MM-YY',
  }
}

@Component({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, StatusOverview, Tree, Legend, MatButtonModule, MatInputModule, MatSelectModule, MatFormFieldModule, MatTooltipModule, MatIconModule, TooltipDEM, TooltipDPM, ChartsModule, ProgressIndefinite, TouchDblclickDirective],
    selector: 'app-status-overview',
    templateUrl: './status-overview.html',
    styleUrls: ['./status-overview.scss', '../widget.scss']
})
export class StatusOverviewWidget extends Widget {
  static override key = 100707
  dialog: any
  @ViewChild("Statusoverview", { static: false }) Statusoverview!: ElementRef;
  @ViewChild('fs') fs!: ElementRef;
  isActive = false;
  window=window;
  private chartSubs: Subscription[] = [];
  private apiSub: Subscription | null = null;
  private orderSub: Subscription | null = null;

  source: any
  clientKey: any
  moduleKey: any
  moduleName:any
  dashboardKey: any
  sourceName: any
  historyFlag:any;
  staticLegend = false;
  staticLegendItems:any=[];
  
  constructor(private routerHandlerService: RouterHandlerService) {
    super();

    this.route.params.subscribe((p: any) => {

      this.moduleName = p['module'] || '';
      this.source = p["cardName"] || '';

      this.route.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);

        this.clientKey = decryptedParams["cl_key"];
        this.moduleKey = decryptedParams["md_key"];
        this.dashboardKey = decryptedParams["ds_key"];
        this.historyFlag = decryptedParams?.["hist_flg"] || undefined;
      });
    });
  }

  override ngOnInit () {
    super.ngOnInit()
    const type = this.item.config['tool_tip_type'].value
    const chartType = this.item.config['type_of_page'].value
    
    this.staticLegend = this.item.config?.['static_legend']?.value == 'true' || false;
    this.config = widgetConfigs[type].config

    if (this.staticLegend && this.item?.config?.['static_legend_selection']) {
      this.staticLegendItems = this.item.config?.['static_legend_selection'] || [];
      this.staticLegendItems = this.staticLegendItems.filter((f:any)=> f.selected);
      this.staticLegendItems = this.staticLegendItems.map((f: any) => ({ ...f , name : f.name.toUpperCase(), marked: (f?.marked == false) ? false : true }));
      
      this.config.statusOverview.view.badgeIndicators =  (serie: any) => {
        const selectedLegends = (this.item?.config?.['static_legend_selection'] || []).filter((item: any) => item.selected);
        const selectedNames = selectedLegends.map((item: any) => item.name.toUpperCase());
        const indicators = [
          { name: "DEFECT", url: "../../../../assets/indicators_svg/defect.svg", icon: "defect", value: !!(serie.failures || serie.errors || serie.on_hold || serie.failure_record_count || serie.error_record_count) },
          { name: "NOTES", url: "../../../../assets/indicators_svg/notes.svg", icon: "notes", value: serie.comment_flg === 'Y' },
          { name: "DELAY", url: "../../../../assets/indicators_svg/delay.svg", icon: "delay", value: serie.delay_ind === 'Y' },
          { name: "AHEAD", url: "../../../../assets/indicators_svg/ahead.svg", icon: "ahead", value: serie.ahead_flg === 'Y' },
          { name: "ON TIME", url: "../../../../assets/indicators_svg/on_time.svg", icon: "on_time", value: serie.on_time_flg === 'Y' },
          { name: "DELAY < 1HR", url: "../../../../assets/indicators_svg/delayLT1hr.svg", icon: "delayLT1hr", value: serie.delay_lt_1hr_flg === 'Y' },
          { name: "DELAY > 1HR", url: "../../../../assets/indicators_svg/delayGT1hr.svg", icon: "delayGT1hr", value: serie.delay_gt_1hr_flg === 'Y' },
          { name: "INTERIM", url: "../../../../assets/indicators_svg/interim.svg", icon: "interim", value: serie.interim_extract_flg === 'Y' },
          { name: "UP TREND", url: "../../../../assets/indicators_svg/up_trend.svg", icon: "up_trend", value: serie.sent_records_up === 'Y' },
          { name: "DOWN TREND", url: "../../../../assets/indicators_svg/down_trend.svg", icon: "down_trend", value: serie.sent_records_down === 'Y' },
          { name: "NO CHANGE", url: "../../../../assets/indicators_svg/no_change.svg", icon: "no_change", value: serie.sent_records_nochange === 'Y' },
          { name: "PARTIAL", url: "../../../../assets/indicators_svg/partial.svg", icon: "partial", value: serie.partial_flg === 'Y' }
        ];
        return indicators.filter(indicator => selectedNames.includes(indicator.name));
      };

    } else {
      this.staticLegendItems = [];
    }
    
    this.subs.push(
      this.filterService.triggerSort.subscribe(() => {
        if (this.config?.statusOverview?.view) {
          this.monthSortOrder();
        }
      })
    );

    this.subs.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        this.dialogServiceMat.closeAll();
        this.chartSubs.forEach(s => s.unsubscribe());
        this.chartSubs = [];
        this.widgetService.set(this.item, { name: 'resetState' })
        this.config.statusOverview = _.merge({}, this.config.statusOverview, { view: { selectedCells: [] } });
        this.data = [];
        this.error_name = '';
        this.isLoading = true
        this.ViewTypeChanges()
        this.loadApiData()
        this.loadOrder()
      })
    )
    
    const itemAccessors = []
    for (let i = 1; i < 10; i++) {
      const element = this.item.config['l' + i + '_col']?.['api_resp_column_nm']
      if (element != undefined) {
        itemAccessors.push(element)
      }
    }
    const colorScheme: string[] = []
    const statuses: string[] = []
    this.item.config['expected_values'].map((e: any) => {
      if (e.isSelected) {
        if (this.item.config.list_of_api.api_key == 200101) statuses.push(e.from_values.toUpperCase())
        else statuses.push(e.from_values)
        colorScheme.push(e.color)
      }
    })
    
    const isFileType = this.item.config.list_of_api?.api_key == 30023;
    const fileAccessor = ['file_type_sub_category'];

    _.merge(this.config.statusOverview.view, {
      calenderSortOrder: this.item.config?.['month_sort']?.value || 'asc',
      itemAccessorsSuffix: [this.item.config?.['tree_label_surffix']],
      cellAppearance: this.item.config?.['cell_appearance']?.name || 'Fill',
      colorScheme,
      statuses,
      itemAccessors,
      itemAccessorsSingleClick: isFileType ? fileAccessor : this.config.statusOverview.view.itemAccessorsSingleClick,
      itemAccessorsDoubleClick: isFileType ? fileAccessor : this.config.statusOverview.view.itemAccessorsDoubleClick,
      itemAccessorsMouseover: isFileType ? fileAccessor : this.config.statusOverview.view.itemAccessorsMouseover,
      itemAccessorsBadge: isFileType ? fileAccessor : this.config.statusOverview.view.itemAccessorsBadge,
      itemAccessorsTotalCount: isFileType ? fileAccessor : this.config.statusOverview.view.itemAccessorsTotalCount,
      timeAccessor: this.item.config['x_axis_column']['api_resp_column_nm'],
      statusAccessor: this.item.config['color_column']['api_resp_column_nm'],
    });

    }

  // View Type changes for calender or table
  ViewTypeChanges():any{
    // debugger
    if(this.filterService.isEmptyObject(this.filterService.baseQuery)) return;
    let filterPayload:any = this.filterService.baseQuery;

    const startDate:any    =  new Date(filterPayload.from_date);
    const endDate:any      =  new Date(filterPayload.to_date);
    const differenceInMs   =  endDate - startDate;
    const differenceInDays:number = ( differenceInMs / (1000 * 60 * 60 * 24))+1;
    const tableCount:number = parseInt(this.item?.config?.['table_count']||16)
    const calenderSortOrder = this.config.statusOverview?.view?.calenderSortOrder || this.item.config?.['month_sort']?.value || 'asc';

    if(this.item.config['type_of_page'].value=="ffm" || this.historyFlag=='H' || this.item.config['type_of_page'].value=="dem"){
      this.config.tree = _.merge({}, this.config.tree, { view: { selectable: (differenceInDays <= tableCount) ? false : true } })
      this.config.statusOverview = _.merge({}, this.config.statusOverview, {view: { viewType: (differenceInDays <= tableCount) ? 'table' : 'calendar', calenderSortOrder}});
      // calendarThreshold: (differenceInDays <= 15) ? 15 : undefined
    } else{
      this.config.tree = _.merge({}, this.config.tree, { view: { selectable: false } })
      this.config.statusOverview = _.merge({}, this.config.statusOverview, {view: { viewType: (differenceInDays <= tableCount) ? 'table' : 'calendar', calenderSortOrder}});
    }
    // console.log(differenceInDays,this.config.statusOverview.view.viewType, this.config.tree.view.selectable);

  }

  loadApiData() {
    const apiConfig = this.item.config.list_of_api
    if (!apiConfig || this.filterService.isEmptyObject(this.filterService.baseQuery)) return

    // Cancel previous in-flight API request
    if (this.apiSub) {
      this.apiSub.unsubscribe();
      this.apiSub = null;
    }

    const query = Object.assign({}, this.filterService.baseQuery, {
      api_key: this.item.config.list_of_api.api_key,
      report_typ: this.filterService.report_type,
      module_key: this.apiService.getModuleKey()
    })

    const endpoint = this.item.config?.["list_of_api_endpoint"] || '';

    this.apiSub = this.httpClient.post(`${this.apiService.apiBaseUrl}/${ endpoint ? endpoint : this.apiService.executionUrl}`, query).pipe(catchError(e => {
        this.data = [];
        this.isLoading = false;
        this.error_name = friendlyApiErrorMessage(e);
        return of([]);
      }),)
      .subscribe((data: any) => {
        this.error_name = '';
        // debugger
        const type = this.item.config['tool_tip_type'].value;
        const commentType = this.item.config['tool_tip_type'].name;
        const dateFormat = widgetConfigs[type].dateFormat

        data.forEach((r: any) => {
         let key = commentType == 'DPM' ? 'cal_day' : 'cycle_dt'
          Object.assign(r, {[key]: moment( commentType == 'DPM' ?r.cal_day:r.cycle_dt).format(dateFormat) })
        })

        // this.data = commentType == 'DPM' ? this.calculateSpikeDipFlags(data, 8, 2) :this.trendFormater(data);
        this.data = commentType == 'DPM' ? data :this.trendFormater(data);
        this.isLoading = false;
        this.config.tree = _.merge({}, this.config.tree, { view: { collapsedAll: true } });
        this.config.statusOverview = { ...this.config.statusOverview, view: { ...this.config.statusOverview.view } };
        this.onChartLoad();
      });
    this.subs.push(this.apiSub);
  }

  // click event for tiles single or double
  onChartLoad () {
    // Unsubscribe previous chart subscriptions to prevent duplicate handlers
    this.chartSubs.forEach(s => s.unsubscribe());
    this.chartSubs = [];

    // click contant
    const clickSub = this.chartService.get(this.config.statusOverview.id, 'selectedCells').subscribe((state: any) => this.toggleModal(state.selectedCells));
    this.chartSubs.push(clickSub);
    this.subs.push(clickSub);

    // dblclick contant
    const dblClickSub = this.chartService.get(this.config.statusOverview.id, 'dblselectedCells').subscribe((state: any) => this.dbltoggleModal(state.dblselectedCells));
    this.chartSubs.push(dblClickSub);
    this.subs.push(dblClickSub);
  }

  loadOrder () {
    // Cancel previous in-flight order request
    if (this.orderSub) {
      this.orderSub.unsubscribe();
      this.orderSub = null;
    }

    let obj = { api_key: '100280' }
    let query = Object.assign({}, this.filterService.baseQuery, obj)
    query['report_typ'] = this.filterService.report_type;
    query['comment_typ'] = this.item.config?.["tree_order_type"] || this.item.config?.["type_of_page"]?.name || 'DPM';

   this.orderSub = this.httpClient.post(`${ this.apiService.apiBaseUrl }/${ this.apiService.executionUrl }`, query)
      .pipe(catchError(e => of([])))
      .subscribe((res: any) => {
        if (!res.length) return
        
        const mergeDesignWithApi:any = [
          {'colDesigner': 'l1_col', 'colResponse': 'level_1'},
          {'colDesigner': 'l2_col', 'colResponse': 'level_2'},
          {'colDesigner': 'l3_col', 'colResponse': 'level_3'},
          {'colDesigner': 'l4_col', 'colResponse': 'level_4'},
          {'colDesigner': 'l5_col', 'colResponse': 'level_5'},
          {'colDesigner': 'l6_col', 'colResponse': 'level_6'},
          {'colDesigner': 'l7_col', 'colResponse': 'level_7'},
        ]

        const itemAccessors:any = [];
        const itemsOrder:any = {};

        mergeDesignWithApi.forEach((f:any)=> {
          if(this.item.config[f.colDesigner]) {
            itemAccessors.push(this.item.config[f.colDesigner].api_resp_column_nm);
            
            if(res[0][f.colResponse]) {
              itemsOrder[this.item.config[f.colDesigner].api_resp_column_nm] = res[0][f.colResponse].split(',');
            }
          }
        })

        // console.log(itemAccessors, itemsOrder)
        this.config.statusOverview.view = Object.assign(this.config.statusOverview.view, { itemsOrder }, {itemAccessors});
      });
    this.subs.push(this.orderSub);
  }

  // fucntion for single click
  toggleModal(cells: any): void {
    this.dialogServiceMat.closeAll();
    if (!cells?.length) return;

    const cell = cells[0];
    const statusData = cell?.status_details?.[cell.status];

    if (!statusData?.details || _.isEmpty(statusData.details)) {
      return this.onModalClose();
    }

    const type = this.item?.config?.['tool_tip_type']?.value;
    if (!type) return;

    this.dialog = this.dialogServiceMat.open(widgetConfigs[type].modal, {
      disableClose: true,
      panelClass: 'status-comment-dialog',
      data: {
        data: { ...cell, ...statusData },
        item: this.item,
        dateFormat: widgetConfigs[type].dateFormat
      }
    });

    this.dialog.afterClosed().subscribe(() => this.onModalClose());
  }

  // function for double clicks
  dbltoggleModal (cells: any) {
    if(cells==undefined)return;
    this.dialogServiceMat.closeAll();
    if (!cells?.length) return;
    if (_.isEmpty(cells[0].status_details[cells[0].status].details)) return this.onModalClose()

    const data = cells[0].status_details[cells[0].status];
    const cfg = this.item.config;
    // Resolve navigation behaviour:
    //  - 'popup'       -> open the control-chart dialog (existing behaviour)
    //  - 'popup_page'  -> render the full detail page inside a popup (page config in a modal)
    //  - 'page'        -> existing page navigation (detailNav)
    let navType: any
    if (cfg?.['navigation']?.value == 'true') {
      const navValue = cfg?.['nav_type']?.value;
      navType = navValue == 'popup' ? 'popup' : navValue == 'popup_page' ? 'popup_page' : 'page';
    }

    if (navType == 'page') { this.detailNav({ ...cells[0], ...data }); return; }

    if (navType == 'popup_page') { this.controlChartPagePopup({ ...cells[0], ...data }); return; }

    if (navType == 'popup') {
      const record = { ...cells[0], ...data };
      const navData = this.buildNavData(record);
      const extraPayload = this.buildExtraPayload(navData);
      const heading = this.buildDialogHeading(record, navData);
      // No fixed height — the popup hugs the chart it renders (see the panelClass rules in
      // styles.scss); a fixed 88vh left a large empty band under the chart.
      this.dialogServiceMat.open(ControlChartDialogComponent, {
        disableClose: false,
        panelClass: 'control-chart-dialog',
        width: '92vw',
        maxWidth: '95vw',
        maxHeight: '90vh',
        data: { navData, extraPayload, heading }
      });
    }
  }

  private buildNavData(record: any): any {
    const file_count = Object.keys(record?.details).length;
    const file_name: any = file_count > 1 ? Object.keys(record?.details) : Object.keys(record?.details)[0];
    const detail: any = Object.values(record?.details)[0];

    const chartType: string = this.item.config['tool_tip_type'].value;
    const dateFormat = widgetConfigs[chartType].dateFormat;

    return {
      ...detail,
      file_type_dim_key: detail.file_type_key,
      cycle_dt: detail.period,
      file_nm: (file_count > 1 ? (file_name as string[]).join(',') : file_name) || detail.file_nm,
      day_of_the_week: String(moment(detail.period, dateFormat).isoWeekday())
    };
  }

  private buildDialogHeading(record: any, navData: any): string {
    const chartType: string = this.item.config['tool_tip_type'].value;
    const dateFormat = widgetConfigs[chartType].dateFormat;
    const displayName: string[] = (record?.yKey || '').split('/');
    const label = displayName[displayName.length - 1] || '';
    const source = navData.source_name || displayName[0] || '';
    const date = navData.cycle_dt
      ? moment(navData.cycle_dt, dateFormat).format('DD MMM YYYY')
      : '';
    return [source, label, date].filter(Boolean).join(' • ');
  }

  // Mirrors storingPayloadAndFilterForGrid — picks the same fields from navData
  // that would have been merged into filterService.baseQuery via page navigation.
  private buildExtraPayload(navData: any): any {
    const navConfig = this.item.config?.['nav_configuration']?.controls?.[0];
    const extra: any = {};

    if (navConfig?.customPayloadKey) extra[navConfig.customPayloadKey] = navConfig.customPayloadValue;
    if (navConfig?.customFilterKey)  extra[navConfig.customFilterKey]  = navConfig.customFilterValue;

    if (navConfig?.payloadData) {
      navConfig.payloadData.split(',').forEach((k: string) => {
        const key = k.trim();
        if (navData[key] !== undefined) extra[key] = navData[key];
      });
    }

    if (navConfig?.filterData) {
      navConfig.filterData.split(',').forEach((k: string) => {
        const key = k.trim();
        if (navData[key] !== undefined) extra[key] = navData[key];
      });
    }

    return extra;
  }

  // Opens the configured detail page inside a popup that runs as a fully ISOLATED page
  // session: PagePopupComponent overrides the stateful page services (FilterService,
  // WidgetService, DashboardService, PageDataService, ...) in its own injector subtree,
  // so nothing here is shared with the parent page.
  //
  // To keep the parent page completely untouched, NO sessionStorage is written. All context
  // (page-config pointer, cell payload, and a *clone* of the parent filter state to seed the
  // popup with) is passed through MAT_DIALOG_DATA. The clone means the popup starts with the
  // same filter context as a normal navigation, but mutating it inside the popup cannot affect
  // the parent's FilterService instance.
  private controlChartPagePopup(record: any): void {
    if (!record?.details || Object.keys(record.details).length === 0) return;

    // Cell context (same data the popup dialog builders produce).
    const navData = this.buildNavData(record);

    // nav_configuration drives the page-config pointer.
    const config = this.item.config?.['nav_configuration']?.controls?.[0];
    const nav = {
      dbJSON: config?.dbJSON,
      s3JSON: config?.s3JSON,
      pageName: config?.pageName,
      isDashboardLevel: config?.isDashboardLevel,
      isNavSelected: config?.isNavSelected,
      navpageName: config?.navpageName,           // router var keys
      navpageNameLeft: config?.navpageNameLeft || '',
      navpageNameRight: config?.navpageNameRight || ''
    };

    // Header used to compose the page title (navHeaderData equivalent).
    const chartType: string = this.item.config['tool_tip_type'].value;
    const dateFormat = widgetConfigs[chartType].dateFormat;
    const displayName: string[] = (record?.yKey || '').split('/');
    const header: any = {
      cycle_dt: navData.cycle_dt ? moment(navData.cycle_dt, dateFormat).format('DD MMM ') + ' ' : '',
      file_type_nm: (displayName[displayName.length - 1] || '') + ' - ',
      source_name: (navData.source_name || '') + ' - '
    };

    // Cell payload/filter the detail page needs -- computed in-memory (NOT stored to session).
    const extraPayload: any = { ...this.buildExtraPayload(navData) };
    if (navData.day_of_the_week != null) extraPayload['day_of_the_week'] = navData.day_of_the_week;
    if (navData.source_key != null) extraPayload['source_key'] = navData.source_key;
    extraPayload['hd_flg'] = navData.show_grid_flg || 'Y';

    // Popup title — "Source • Label • DD MMM YYYY" format.
    const heading = this.buildDialogHeading(record, navData);

    // Deep clone of the parent filter slices that seed the popup's isolated FilterService.
    // Cloning (not referencing) is what guarantees popup edits never reach the parent.
    // The scalar props are what setFilterValue() reads to (re)build baseQuery, so seeding them
    // makes the popup's own filter widget re-emit the SAME context instead of failing.
    const fs: any = this.filterService;
    const parentFilterState = {
      baseQuery: _.cloneDeep(fs.baseQuery || {}),
      badges: _.cloneDeep(fs.badges || []),
      model: _.cloneDeep(fs.model || {}),
      previousModel: _.cloneDeep(fs.previousModel || {}),
      duplicateParameter: _.cloneDeep(fs.duplicateParameter || {}),
      reportType: fs.report_type,
      timeCycle: fs.time_cycle,
      dayOfWeek: fs.day_of_the_week,
      bufferDays: fs.buffer_days,
      startDate: fs.startDate,
      endDate: fs.endDate,
      sourceKey: fs.source_key
    };

    // Open the full page inside a modal (no route change). Lazy import avoids a static
    // circular dependency: WidgetModule imports this widget, and the popup imports WidgetModule.
    import('./page-popup/page-popup.component').then(({ PagePopupComponent }) => {
      this.dialogServiceMat.open(PagePopupComponent, {
        disableClose: false,
        closeOnNavigation: false,
        panelClass: 'page-popup-dialog',
        width: '92vw',
        maxWidth: '95vw',
        height: '88vh',
        data: {
          heading,
          navDetailInfo: nav,
          navHeaderData: header,
          navConfig: config,
          selectConfig: sessionStorage.getItem('selectConfig') || 'S3',
          extraPayload,
          parentFilterState,
          keys: {
            clientKey: this.clientKey,
            moduleKey: this.moduleKey,
            dashboardKey: this.dashboardKey,
            moduleName: this.moduleName
          }
        }
      });
    }).catch((err) => {
      console.error('Failed to open page popup', err);
    });
  }

  // navigation method
  detailNav(record: any) {
    // debugger
    if(Object.keys(record?.details).length==0) return;
    const displayName = record?.yKey.split('/')
    const file_count = Object.keys(record?.details).length;

    let file_name:any = file_count > 1 ? Object.keys(record?.details):Object.keys(record?.details)[0]
    record = Object.values(record?.details)[0];

    const chartType:string = this.item.config['tool_tip_type'].value;
    const dateFormat = widgetConfigs[chartType].dateFormat;

    let myData:any = record;
    myData['file_type_dim_key'] = record.file_type_key;
    myData['cycle_dt'] = record.period;
    myData['file_nm'] = (file_count > 1 ? file_name.join(',') : file_name )|| record.file_nm;
    myData['day_of_the_week'] = String(moment(record.period, dateFormat).isoWeekday());

    let header:any={
      'cycle_dt':moment(record.period, dateFormat).format('DD MMM ')+' ',
      'file_type_nm': displayName[displayName.length-1]+' - ',//((file_count > 1) ? displayName[displayName.length-1] : file_name )+' - ',
      'source_name':record.source_name+' - '
    }
    // 'file_type_nm': record.file_type+' - ',
    
    let strQuery = '';
    for(let key in header) {
      if(header[key]) {
        strQuery += header[key]
      }
    }

    // Set Navigation
    const config = this.item.config?.['nav_configuration'].controls?.[0];
    let nav = {
      dbJSON: config?.dbJSON,
      s3JSON: config?.s3JSON,
      pageName: config?.pageName,
      isDashboardLevel: config?.isDashboardLevel,
      isNavSelected:config?.isNavSelected,
      navpageName:config?.navpageName,//router var keys
      navpageNameLeft:config?.navpageNameLeft|| '',
      navpageNameRight:config?.navpageNameRight|| ''
    }
    sessionStorage.setItem("navDetailInfo", JSON.stringify(nav));
    sessionStorage.setItem("navHeaderData", JSON.stringify(header));
    this.routerHandlerService.storingPayloadAndFilterForGrid(config, myData, '');
    // this.sourceName = myData['source_nm'];

    let query = {
      tab_id: 0,
      cl_key: this.clientKey,
      md_key: this.moduleKey,
      ds_key: this.dashboardKey,
      hd_flg:record.show_grid_flg||'Y',
      f_q: strQuery
    }

    this.navigationService.routerNavigate(`dashboard/${this.moduleName}/${nav.pageName}`, query);
  }

  // expand & collapse   method 
  toggleAll(event:any) {
    this.config.tree = _.merge({}, this.config.tree, { view: { collapsedAll: !event }});
    // { view: { collapsedAll: !this.config.tree.view?.collapsedAll } })
  }

  // refresh the grid when closed;
  onModalClose() {
    this.config.statusOverview = _.merge({}, this.config.statusOverview, { view: { selectedCells: [] } });
  
    const commentType = this.item.config['tool_tip_type'].name;
    let colorColumn = this.item?.config?.['color_column']?.['api_resp_column_nm'];
  
    // Check if currentMsgOnDM is an array or a single object
    const isArray = Array.isArray(this.filterService.currentMsgOnDM);
  
    if (isArray && this.filterService.currentMsgOnDM.length > 0) {
      let flg_Da = this.filterService.currentMsgOnDM[0];  // Array case
      
      this.data.forEach((res: any) => {
        const formattedDate = moment(commentType === 'DPM' ? res?.cal_day : res?.cycle_dt, commentType === 'DPM' ? 'DD-MM-YY' : 'yyyy-MM-DD').format('yyyy-MM-DD');
        const commentsDate =moment(flg_Da?.period, 'yyyy-MM-DD').format('yyyy-MM-DD') 
        if (res?.source_key === flg_Da?.data_source_key &&
            formattedDate === commentsDate &&
            res?.['file_type_key'] === flg_Da?.['file_type_key'] && res?.['refresh_no'] == flg_Da?.['refresh_no'] &&
            (res?.[colorColumn] === flg_Da?.['file_status'] || res?.[colorColumn] === flg_Da?.['process_result'])) {
          Object.assign(res, { 'comment_flg': 'Y' });
        }
      });
    } else if (!isArray && this.filterService.currentMsgOnDM) { // Single object case
      let flg = this.filterService.currentMsgOnDM;  // Single object
      
      this.data.forEach((res: any) => {
        const formattedDate = moment(commentType === 'DPM' ? res?.cal_day : res?.cycle_dt, commentType === 'DPM' ? 'DD-MM-YY' : 'yyyy-MM-DD').format('yyyy-MM-DD');
        if (res?.source_key === flg?.source_key &&
            formattedDate === moment(flg?.period, commentType === 'DPM' ? 'DD-MM-YY' : 'yyyy-MM-DD').format('yyyy-MM-DD') &&
            res?.['file_type_key'] === flg?.['file_type_key'] && res?.['refresh_no'] == flg?.['refresh_no'] &&
            (res?.[colorColumn] === flg?.['file_status'] || res?.[colorColumn] === flg?.['process_result'])) {
          Object.assign(res, { 'comment_flg': 'N' });
        }
      });
    }
  }
  
  trendFormater(data: any): any {
    const config = this.item.config;

    // Collect all defined level columns dynamically (e.g., l1_col, l2_col, l3_col)
    const levelCols = ['l1_col', 'l2_col', 'l3_col']
      .map(key => config[key]?.api_resp_column_nm)
      .filter(Boolean); // Removes undefined ones

    const dateVar = config['x_axis_column']?.api_resp_column_nm;

    // Sort data based on levels and date
    data.sort((a: any, b: any) => {
      for (let col of levelCols) {
        if (a[col] !== b[col]) {
          return String(a[col]).localeCompare(String(b[col]));
        }
      }
      return new Date(a[dateVar]).getTime() - new Date(b[dateVar]).getTime();
    });

    for (let i = 0; i < data.length; i++) {
      const current = data[i];
      const prev = data[i - 1];

      // First row of entire dataset OR first row of group → no trend
      if (i === 0 || !levelCols.every(col => current[col] === prev[col])) {
        current.sent_records_trend = 'no trend';
        current.sent_records_up = 'N';
        current.sent_records_down = 'N';
        current.sent_records_nochange = 'N';

        current.on_hold_trend = 'no trend';
        current.on_hold_up = 'N';
        current.on_hold_down = 'N';
        current.on_hold_nochange = 'N';

        continue;
      }

      // =====► SENT RECORDS TREND
      // Skip trend indicators when sent_records is null/undefined
      if (current.sent_records == null || prev.sent_records == null) {
        current.sent_records_trend = 'no trend';
        current.sent_records_up = 'N';
        current.sent_records_down = 'N';
        current.sent_records_nochange = 'N';
      } else {
        const prevSent = prev.sent_records || 0;
        const currSent = current.sent_records || 0;

        if (currSent > prevSent) {
          current.sent_records_trend = 'up';
          current.sent_records_up = 'Y';
          current.sent_records_down = 'N';
          current.sent_records_nochange = 'N';
        } else if (currSent < prevSent) {
          current.sent_records_trend = 'down';
          current.sent_records_up = 'N';
          current.sent_records_down = 'Y';
          current.sent_records_nochange = 'N';
        } else {
          current.sent_records_trend = 'nochange';
          current.sent_records_up = 'N';
          current.sent_records_down = 'N';
          current.sent_records_nochange = 'Y';
        }
      }

      // =====► ON HOLD TREND
      const prevHold = prev.on_hold || 0;
      const currHold = current.on_hold || 0;

      if (currHold > prevHold) {
        current.on_hold_trend = 'up';
        current.on_hold_up = 'Y';
        current.on_hold_down = 'N';
        current.on_hold_nochange = 'N';
      } else if (currHold < prevHold) {
        current.on_hold_trend = 'down';
        current.on_hold_up = 'N';
        current.on_hold_down = 'Y';
        current.on_hold_nochange = 'N';
      } else {
        current.on_hold_trend = 'nochange';
        current.on_hold_up = 'N';
        current.on_hold_down = 'N';
        current.on_hold_nochange = 'Y';
      }
    }

    // Return sorted DESC at the end
    return _.orderBy(data, dateVar, 'desc');
  }
  monthSortOrder() {
    const currentOrder = this.config.statusOverview.view?.calenderSortOrder;
    const newOrder = currentOrder === 'asc' ? 'desc' : 'asc';

    this.config.statusOverview = {
      ...this.config.statusOverview,
      view: {
        ...this.config.statusOverview.view,
        calenderSortOrder: newOrder
      }
    };

    // Force data reference change (if needed)
    this.data = [...this.data];
  }

 interactiveLegend(item: any, idx: number) {
    this.staticLegendItems[idx].marked = !this.staticLegendItems[idx].marked;

    const indicators = [
      { name: "DEFECT", icon: "defect" },
      { name: "NOTES", icon: "notes" },
      { name: "DELAY", icon: "delay" },
      { name: "INTERIM", icon: "interim" },
      { name: "UP TREND", icon: "up_trend" },
      { name: "DOWN TREND", icon: "down_trend" },
      { name: "NO CHANGE", icon: "no_change" },
      { name: "PARTIAL", icon: "partial" },
      { name: "ANOMALY", icon: "anomaly" },
      { name: "AHEAD", icon: "ahead" },
      { name: "ON TIME", icon: "on_time" },
      { name: "DELAY < 1HR", icon: "delayLT1hr" },
      { name: "DELAY > 1HR", icon: "delayGT1hr" }
      
    ];
    
    let markedFalse = this.staticLegendItems.filter((f: any) => f.marked);

    // Match based on NAME only
    let indca = indicators.filter(x =>
      markedFalse.find((d: any) => d.name === x.name)
    );

    // DUCharts wants "UP TREND", "DOWN TREND", "NO CHANGE"
    const key = indca.map(m => m.name.toUpperCase());
  if(this.staticLegendItems[idx].name!='ANOMALY'){
    this.config.statusOverview.view.badgeIndicators =  (serie: any) => {
      const indicators = [
        { name: "DEFECT", url: "../../../../assets/indicators_svg/defect.svg", icon: "defect", value: !!(serie.failures || serie.errors || serie.on_hold || serie.failure_record_count || serie.error_record_count) },
        { name: "NOTES", url: "../../../../assets/indicators_svg/notes.svg", icon: "notes", value: serie.comment_flg === 'Y' },
        { name: "DELAY", url: "../../../../assets/indicators_svg/delay.svg", icon: "delay", value: serie.delay_ind === 'Y' },
        { name: "AHEAD", url: "../../../../assets/indicators_svg/ahead.svg", icon: "ahead", value: serie.ahead_flg === 'Y' },
        { name: "ON TIME", url: "../../../../assets/indicators_svg/on_time.svg", icon: "on_time", value: serie.on_time_flg === 'Y' },
        { name: "DELAY < 1HR", url: "../../../../assets/indicators_svg/delayLT1hr.svg", icon: "delayLT1hr", value: serie.delay_lt_1hr_flg === 'Y' },
        { name: "DELAY > 1HR", url: "../../../../assets/indicators_svg/delayGT1hr.svg", icon: "delayGT1hr", value: serie.delay_gt_1hr_flg === 'Y' },
        { name: "INTERIM", url: "../../../../assets/indicators_svg/interim.svg", icon: "interim", value: serie.interim_extract_flg === 'Y' },
        { name: "UP TREND", url: "../../../../assets/indicators_svg/up_trend.svg", icon: "up_trend", value: serie.sent_records_up === 'Y' },
        { name: "DOWN TREND", url: "../../../../assets/indicators_svg/down_trend.svg", icon: "down_trend", value: serie.sent_records_down === 'Y' },
        { name: "NO CHANGE", url: "../../../../assets/indicators_svg/no_change.svg", icon: "no_change", value: serie.sent_records_nochange === 'Y' },
        { name: "PARTIAL", url: "../../../../assets/indicators_svg/partial.svg", icon: "partial", value: serie.partial_flg === 'Y' }
      ];
      return indicators.filter(indicator => key.includes(indicator.name));
    };
  }else{

    this.config.statusOverview.view.borderBadgeAccessor =  (serie: any) => {
      //add the proper ondition for INTERIM
     const Border= this.staticLegendItems[idx].marked && (serie.spike_flg === 'Y' ||serie.dip_flg === 'Y')
      return Border
    }
    }
    const view = { ...this.config.statusOverview.view };

    this.config.statusOverview = {
      ...this.config.statusOverview,
      view: null
    };

    setTimeout(() => {
      this.config.statusOverview = {
        ...this.config.statusOverview,
        view: { ...view }
      };
    });

    // this.chartService.set('data-load-status-static-legend', {
    //   disabled: key,
    //   rotateCondition: true
    // });
  }

  override ngOnDestroy(): void {
    this.config.statusOverview = _.merge({}, this.config.statusOverview, { view: { selectedCells: [] } });
    this.dialogServiceMat.closeAll();
    this.subs.forEach(res=> res.unsubscribe())
    try {
      this.chartService.remove('data-load-status-static-legend');
    } catch (e) {
      // State may not exist if chart was destroyed before fully initializing
    }
    this.config.statusOverview.view.borderBadgeAccessor =  (serie: any) => {
     return false
   }
  }

    calculateSpikeDipFlags(rawData: any[],look_back_period = 8,stdev_multiplier = 2): any[] {
      // Group by source + file_type
      const grouped = new Map<string, any[]>();
      rawData.forEach(item => {
        const key = `${item.source_name}||${item.file_type}`;
        if (!grouped.has(key)) grouped.set(key, []);
        grouped.get(key)!.push({ ...item });
      });

      const result: any[] = [];

      for (const [key, series] of grouped) {
        const sorted = series.sort((a, b) =>
          new Date(a.cal_day).getTime() - new Date(b.cal_day).getTime()
        );

        // Convert null → 0, keep original no_of_records for output if needed
        const processed = sorted.map(item => ({
          ...item,
          value: item.no_of_records ?? 0, // ✅ null becomes 0
        }));

        for (let i = 0; i < processed.length; i++) {
          const current = processed[i];

          // ➕ If calc_flg = 'N', preserve original flags
          if (current.calc_flg === 'N') {
            result.push({
              ...current,
              spike_flg: current.spike_flg ?? 'N',
              dip_flg: current.dip_flg ?? 'N',
              normal_flg: current.normal_flg ?? 'Y',
              no_of_records: current.no_of_records, // keep original (null or number)
            });
            continue;
          }

          // 🔁 calc_flg = 'Y' → always calculate (even with 1 data point)
          let spike: 'Y' | 'N' = 'N';
          let dip: 'Y' | 'N' = 'N';
          let normal: 'Y' | 'N' = 'Y';

          // Look back up to `look_back_period` days (only past records)
          const startIndex = Math.max(0, i - look_back_period);
          const windowValues = processed
            .slice(startIndex, i) // exclude current
            .map(d => d.value);   // value is never null (null → 0)

          if (windowValues.length === 0) {
            // No history at all → treat as normal
            // (e.g., first record in series)
          } else {
            // Always compute, even if window has 1 element
            const n = windowValues.length;
            const sum = windowValues.reduce((a, b) => a + b, 0);
            const avg = sum / n;

            // Variance: use population formula (divide by n)
            const variance = windowValues.reduce((sum, val) => sum + (val - avg) ** 2, 0) / n;
            const std = Math.sqrt(variance);

            const ucl = avg + stdev_multiplier * std;
            const lcl = avg - stdev_multiplier * std;

            if (current.value > ucl) {
              spike = 'Y';
              dip = 'N';
              normal = 'N';
            } else if (current.value < lcl) {
              spike = 'N';
              dip = 'Y';
              normal = 'N';
            }
            // else: remains normal
          }

          result.push({
            ...current,
            spike_flg: spike,
            dip_flg: dip,
            normal_flg: normal,
            no_of_records: current.no_of_records, // preserve original (null stays null)
          });
        }
      }

      // Restore original input order
      const originalOrderMap = new Map(
        rawData.map((r, idx) => [`${r.cal_day}-${r.source_name}-${r.file_type}`, idx])
      );

      return result.sort((a, b) => {
        const keyA = `${a.cal_day}-${a.source_name}-${a.file_type}`;
        const keyB = `${b.cal_day}-${b.source_name}-${b.file_type}`;
        return (originalOrderMap.get(keyA) ?? 0) - (originalOrderMap.get(keyB) ?? 0);
      });
    }

    trackByLegend(index: number, item: any): any {
    return item.id || item.name;
    }

}